module.exports = __webpack_public_path__ + "images/d0587dddf0940fa64bb3d097c730b85c3563dbbb4829d3b39dacfc23d25b685f.svg";